// frontend/src/components/Mobile/MobileNoAccess.jsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiLock, FiLogOut } from 'react-icons/fi';
import './Mobile.css';

const MobileNoAccess = () => {
  const { logout } = useAuth();
  return (
    <div className="mb-login">
      <div className="mb-login-logo"><FiLock size={28} /></div>
      <h1>Sem acesso</h1>
      <p className="mb-login-sub">
        O seu utilizador não tem permissões para nenhum ecrã mobile.
        Contacte o administrador.
      </p>
      <button type="button" className="mb-btn-primary" onClick={logout}>
        <FiLogOut size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />
        Sair
      </button>
    </div>
  );
};

export default MobileNoAccess;